// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1_Utb","cls2":"SimplePaperPodcast-cls2_zJr SimplePaperPodcast-cls1_Utb"};